import { EnvironmentProviders } from '@angular/core';
import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';
import { leadQueueEffects } from 'src/app/lead-queue/store/effects';
import { leadQueueFeatureKey } from 'src/app/lead-queue/store/reducers';
import { leadQueueReducer } from 'src/app/lead-queue/store/reducers/lead-queue.reducers';

export const provideLeadQueueStore = (): EnvironmentProviders[] => [
    provideState(leadQueueFeatureKey, leadQueueReducer),
    provideEffects(leadQueueEffects)
];
